export const iconFontAwesomeFilesFileCsv = (
	<i className="fa-solid fa-file-csv"></i>
);
